/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const addCustomerKnownNumberBodyNumberMax = 80;

export const addCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin = 0;
export const addCustomerKnownNumberBodyExpectedCustomerVersionMax = 9007199254740991;

export const AddCustomerKnownNumberBody = zod.object({
  number: zod.string().min(1).max(addCustomerKnownNumberBodyNumberMax),
  expectedCustomerVersion: zod
    .int()
    .gt(addCustomerKnownNumberBodyExpectedCustomerVersionExclusiveMin)
    .max(addCustomerKnownNumberBodyExpectedCustomerVersionMax),
});

export type AddCustomerKnownNumberBody = zod.input<typeof AddCustomerKnownNumberBody>;
export type AddCustomerKnownNumberBodyOutput = zod.output<typeof AddCustomerKnownNumberBody>;
